import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = { class: "col-md-12 px-3" };
const _hoisted_4 = { class: "modal-footer justify-between" };
const _hoisted_5 = { class: "col p-0" };
const _hoisted_6 = { class: "col-auto text-end p-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["BModal"], {
        ref: "changeTenantModal",
        "no-footer": "",
        centered: "",
        size: "lg",
        title: `${_ctx.$t('JTADM_TENANTS_TENANT_CHANGE')} : ${$setup.currentUserStore.tenantName || 'N/A'}`
    }, {
        default: _withCtx(() => [
            (!$setup.tenantsResult.loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("form", null, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                ($setup.tenants)
                                    ? (_openBlock(), _createBlock($setup["Multiselect"], {
                                        key: 0,
                                        modelValue: $setup.currentTenant,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.currentTenant) = $event)),
                                        "data-cy": "change-tenant-input",
                                        "custom-label": $setup.customLabelTenant,
                                        "max-height": 250,
                                        options: $setup.tenants,
                                        searchable: true
                                    }, null, 8, ["modelValue", "options"]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("footer", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode($setup["BButton"], {
                                variant: "danger",
                                onClick: _cache[1] || (_cache[1] = ($event) => ($setup.changeTenantModal?.hide()))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            ($setup.currentTenant)
                                ? (_openBlock(), _createBlock($setup["BButton"], {
                                    key: 0,
                                    variant: "success",
                                    onClick: $setup.confirm
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('JTADM_UPDATE')), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["title"]));
}
